import { IconFileAvi, IconFileDoc, IconFileDocx, IconFileGeoTiff, IconFileIfc, IconFileImage, IconFileLas, IconFileLaz, IconFileMp4, IconFilePdf, IconFileShp, IconFileTif, IconFileTiff, IconFileTxt, IconFileUndefined, IconFileXls, IconFileXlsX, IconFileZip } from "@synthesis/shared-icons";
import { jsx } from "react/jsx-runtime";
//#region src/FileIconComponent/index.tsx
const extensionIconsMap = {
	pdf: IconFilePdf,
	avi: IconFileAvi,
	doc: IconFileDoc,
	docx: IconFileDocx,
	geotiff: IconFileGeoTiff,
	tiff: IconFileTiff,
	tif: IconFileTif,
	ifc: IconFileIfc,
	las: IconFileLas,
	laz: IconFileLaz,
	mp4: IconFileMp4,
	shp: IconFileShp,
	txt: IconFileTxt,
	xls: IconFileXls,
	xlsx: IconFileXlsX,
	zip: IconFileZip
};
const imageFormats = {
	jpeg: true,
	jpg: true,
	png: true,
	gif: true,
	bmp: true,
	webp: true,
	raw: true,
	svg: true,
	heif: true,
	ico: true
};
const getIconByExtension = (ext) => {
	if (ext in extensionIconsMap) return extensionIconsMap[ext];
	if (ext in imageFormats) return IconFileImage;
};
const defaultStyle = { color: "#ECE5E3" };
const FileIconComponent = ({ ext = "", className, style, ...other }) => {
	const Icon = getIconByExtension(ext.toLowerCase()) ?? IconFileUndefined;
	return /* @__PURE__ */ jsx(Icon, {
		className,
		style: {
			...defaultStyle,
			...style
		},
		...other
	});
};
//#endregion
export { FileIconComponent };

//# sourceMappingURL=index.js.map